import React from 'react';
import { RhCheckbox } from '../../../../../../../dum';
import { IS_INACTIVE } from '../../employee-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

// Replaces the old status dropdown: checked = dado de baja (no longer active).
export function EmployeeInactiveInput() {
    return (
        <RhCheckbox
            name={IS_INACTIVE}
            label={shortLabel(FIELD_LABELS.is_inactive)}
            disableGutters
        />
    );
}
